module.exports = __webpack_public_path__ + "img/sample-category.92636e61.jpg";